import { BRAND_NAME } from "../../constants/brand";
import { Grid, Typography, Link } from "@mui/material"
import footerStyles from "../../Styles/ComponentStyles/FooterStyles/Footer.module.scss"
import newRBlogo from "../../assets/Images/mar-lockup-white.svg"
import { DISCLAIMER_TITLE, DISCLAIMER_PARAGRAPHS, disclaimerDateLine } from "../../config/disclaimer"

// /disclaimer: the one disclaimer text (src/config/disclaimer.ts), the same paragraphs the sign-in block renders (RB-326, legal-brand-15)
const DisclaimerPage = () => {
    return (
        <>
            <Grid container className={footerStyles.footerPagesMainComponent} justifyContent="center">
                <Grid item xs={12} className={footerStyles.logoContainer}>
                    <img src={newRBlogo} alt={BRAND_NAME} />
                </Grid>

                <Grid
                    item
                    sm={11} xs={11} md={10} lg={9} xl={7}
                    className={footerStyles.footerPagesTextContainer}
                >
                    <Grid container className="paraData">
                        <Grid item sm={12} xs={12} textAlign="center" className={footerStyles.titleContainer}>
                            <Typography className={footerStyles.pageTitle}>{DISCLAIMER_TITLE}</Typography>
                        </Grid>

                        <Grid item sm={12} xs={12} padding={"30px"}>
                            <Grid container gap={2}>
                                {DISCLAIMER_PARAGRAPHS.map((paragraph, index) => (
                                    <Grid item sm={12} xs={12} key={index}>
                                        <Typography component='p' className={footerStyles.textStyle} data-testid="disclaimer-paragraph">
                                            {paragraph}
                                        </Typography>
                                    </Grid>
                                ))}
                                <Grid item sm={12} xs={12}>
                                    <Typography component='p' className={footerStyles.textStyle} data-testid="disclaimer-closing">
                                        See the{' '}
                                        <Link href="/user-agreement" underline="hover">User Agreement</Link>
                                        {' '}and the{' '}
                                        <Link href="/privacy-policy" underline="hover">Privacy Policy</Link>
                                        {' '}for the publisher's identity, the terms of use and the privacy practices. {disclaimerDateLine()}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default DisclaimerPage